module.exports = __webpack_public_path__ + "img/facebook.a9144b71.svg";